<template>
  <div class="QRCode">
    <div class="operation-chunk">
      <div class="close-icon icon iconfont icon-close" @click="again"></div>
      <div class="operation-title" v-if="type === '0'">下单成功！</div>
      <div class="operation-content">
        <p>扫码给口味命名</p>
        <div class="QRCode-chunk">
          <canvas id="canvas"></canvas>
          <div class="canvas-chunk">
            <div class="canvas-border"></div>
          </div>
        </div>
      </div>
      <div class="operation-btns" v-if="type === '0'">
        <div class="QRCode-btn again" @click="again">再来一锅</div>
        <div class="QRCode-btn" @click="toSelect">去点菜</div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
import mainUtils from "../../pub/utils/mainUtils";

export default {
  name: "QRCode",
  data() {
    return {
      qrcodeUrl: "",
      tableBillId: "",
      memberId: "",
      type: "0",
    };
  },
  methods: {
    useqrcode() {
      let canvas = document.getElementById("canvas");
      QRCode.toCanvas(canvas, this.qrcodeUrl, function (error) {
        if (error) console.error(error);
        // console.log('success!');
      });
    },
    again() {
      return WebViewJavascriptBridge.go2pot();
    },
    toSelect() {
      return WebViewJavascriptBridge.go2dish();
    },
  },
  created() {
    document.documentElement.style.fontSize =
      document.documentElement.clientWidth / 20.48 + "px";
  },
  mounted() {
    // document.documentElement.style.fontSize = document.documentElement.clientWidth / 20.48 + 'px';
    let pathName = mainUtils.pathName();
    for (let i in pathName) {
      this[i] = pathName[i];
    }
    if (process.env.NODE_ENV == "production") {
      this.qrcodeUrl = `https://q.haidilao.com/#/shareSelect_new?tableBillId=${this.tableBillId}&memberId=${this.memberId}`;
    } else {
      // this.qrcodeUrl = `http://test-hdl-internationalization.hhtdev.com:8132/#/shareSelectNew?tableBillId=${this.tableBillId}&memberId=${this.memberId}`;
      this.qrcodeUrl = `https://testpos.hdltest.com:8132/#/shareSelect_new?tableBillId=${this.tableBillId}&memberId=${this.memberId}`;
    }
    this.useqrcode();
  },
};
</script>
<style lang="stylus" scoped>
.QRCode {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: transparent;

  .operation-chunk {
    position: relative;
    width: 8rem;
    background: transparent;

    .operation-title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 1.96rem;
      font-size: 0.56rem;
      color: #fff;
      background: #000;
      border-top-left-radius: 0.1rem;
      border-top-right-radius: 0.1rem;
    }

    .operation-content {
      width: 100%;
      height: 6.14rem;
      background: #fff;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 2.3rem;
        font-size: 0.44rem;
      }

      #canvas {
        width: 3rem !important;
        height: 3rem !important;
      }

      .QRCode-chunk {
        position: relative;
        width: 3rem;
        height: 3rem;
        margin: 0 auto;
      }

      .canvas-chunk {
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 2.8rem;
        height: 2.8rem;
        margin: auto;
        border: 0.05rem solid #d43d3d;
        border-radius: 0.04rem;

        .canvas-border {
          position: absolute;
          z-index: 999;
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 0.1rem;
        }

        .canvas-border:before {
          content: '';
          position: absolute;
          top: -0.05rem;
          left: 50%;
          z-index: 999;
          width: 1.86rem;
          height: 100%;
          margin-left: -0.93rem;
          border-bottom: 0.05rem solid #fff;
          border-top: 0.05rem solid #fff;
        }

        .canvas-border:after {
          content: '';
          position: absolute;
          top: 50%;
          z-index: 999;
          left: -0.05rem;
          width: 100%;
          height: 1.86rem;
          margin-top: -0.93rem;
          border-left: 0.05rem solid #fff;
          border-right: 0.05rem solid #fff;
        }
      }
    }

    .operation-btns {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      height: 1.2rem;

      .QRCode-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.99rem;
        height: 100%;
        font-size: 0.46rem;
        background: #d43d3d;
        color: #fff;
      }
    }

    .close-icon {
      position: absolute;
      top: -0.53rem;
      right: -0.53rem;
      font-size: 1.06rem;
      color: #fff;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
<style lang="stylus">
html, body {
  background-color: transparent !important;
}
</style>


// WEBPACK FOOTER //
// src/components/QRCode/QRCode.vue